import React from 'react';
import PropTypes from 'prop-types';
import shieldPath from '../../media/shield.svg';
import monarkShieldPath from '../../media/monarxShield.svg';
import * as Styles from './ProtectionCard.styles';

export function ProtectionCardRoot({ testId, children }) {
  return (
    <Styles.Card data-component="ProtectionCardCompound" data-testid={testId}>
      {children}
    </Styles.Card>
  );
}

ProtectionCardRoot.propTypes = {
  testId: PropTypes.string,
  children: PropTypes.node,
};

export function ProtectionCardBody({ children }) {
  return <Styles.Content>{children}</Styles.Content>;
}

ProtectionCardBody.propTypes = {
  children: PropTypes.node,
};

export function ProtectionCardShield({ title }) {
  return (
    <Styles.ShieldIcon>
      <Styles.ShieldImage src={shieldPath} alt={title} />
    </Styles.ShieldIcon>
  );
}

ProtectionCardShield.propTypes = {
  title: PropTypes.string.isRequired,
};

export function ProtectionCardTextBlock({ children }) {
  return <Styles.TextWrapper>{children}</Styles.TextWrapper>;
}

ProtectionCardTextBlock.propTypes = {
  children: PropTypes.node,
};

export function ProtectionCardTitle({ children }) {
  return <Styles.Title>{children}</Styles.Title>;
}

ProtectionCardTitle.propTypes = {
  children: PropTypes.node,
};

export function ProtectionCardDescription({ html }) {
  if (!html) {
    return null;
  }
  return <Styles.Description dangerouslySetInnerHTML={{ __html: html }} />;
}

ProtectionCardDescription.propTypes = {
  html: PropTypes.string,
};

ProtectionCardDescription.defaultProps = {
  html: '',
};

export function ProtectionCardActions({ actionsTestId, children }) {
  return (
    <Styles.ButtonsWrapper data-testid={actionsTestId}>
      {children}
    </Styles.ButtonsWrapper>
  );
}

ProtectionCardActions.propTypes = {
  actionsTestId: PropTypes.string,
  children: PropTypes.node,
};

export function ProtectionCardButton({
  variant,
  hasMultipleButtons,
  onClick,
  children,
  testId,
}) {
  return (
    <Styles.ActionButton
      type="button"
      variant={variant}
      hasMultipleButtons={hasMultipleButtons}
      onClick={onClick}
      data-testid={testId}
    >
      {children}
    </Styles.ActionButton>
  );
}

ProtectionCardButton.propTypes = {
  variant: PropTypes.string,
  hasMultipleButtons: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.node,
  testId: PropTypes.string,
};

ProtectionCardButton.defaultProps = {
  variant: 'primary',
  hasMultipleButtons: false,
  onClick: undefined,
  testId: undefined,
};

export function ProtectionCardButtonLink({
  href,
  onClick,
  children,
  testId,
}) {
  return (
    <Styles.ActionButtonLink href={href} onClick={onClick} data-testid={testId}>
      {children}
    </Styles.ActionButtonLink>
  );
}

ProtectionCardButtonLink.propTypes = {
  href: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node,
  testId: PropTypes.string,
};

ProtectionCardButtonLink.defaultProps = {
  href: undefined,
  onClick: undefined,
  testId: undefined,
};

export function ProtectionCardMonarx({ title }) {
  return (
    <Styles.MonarxIcon>
      <Styles.MonarxImage src={monarkShieldPath} alt={title} />
    </Styles.MonarxIcon>
  );
}

ProtectionCardMonarx.propTypes = {
  title: PropTypes.string.isRequired,
};
